import { getObject, removeKey, setObject } from '@/services/localStorage';
import Immutable from 'immutable';

const RECENTLY_VISITED = 'recently-visited';
const MAX_SIZE = 10;

export const addToRecentlyVisited = recent => {
    let visited = loadRecentlyVisited();
    visited = visited.set(recent.get('sportEventId'), recent).sortBy(e => -e.get('timestamp'));

    if (visited.size > MAX_SIZE) {
        visited = visited.slice(0, MAX_SIZE);
    }

    saveRecentlyVisited(visited);
};

export const clearRecentlyVisisted = () => removeKey(RECENTLY_VISITED);

export const loadRecentlyVisited = () =>
    Immutable.fromJS(getObject(RECENTLY_VISITED) || {}).sortBy(e => -e.get('timestamp'));

const saveRecentlyVisited = visited => setObject(RECENTLY_VISITED, visited.toJS());
